import React, { memo, useCallback, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RouteOnMount } from 'utils/routes';
import EmailEditor from './marketing/EmailEditor';
import InitialSetup from './marketing/InitialSetup';
import MarketingCampaigns from './marketing';
import Subscribers from './marketing/Subscribers';
import MarketingCampaignsForm from './marketing/MarketingCampaignsForm';
import MarketingGeneralRoute from './marketing/wrappers/MarketingGeneralRoute';
import MarketingManagementRoute from './marketing/wrappers/MarketingManagementRoute';
import MarketingSettings from './marketing/settings';
import { logMarketingCampaignsEvent } from './marketing/utils/marketingTracking';

const MarketingCampaignsContainer = memo(() => {
    const [isSubscribersOpen, setIsSubscribersOpen] = useState(false);
    const handleOpenSubscribers = useCallback(() => {
        setIsSubscribersOpen(true);
    }, []);

    const handleCloseSubscribers = useCallback(() => {
        setIsSubscribersOpen(false);
    }, []);

    return (
        <>
            <Routes>
                <Route
                    path="/email-editor"
                    element={
                        <RouteOnMount
                            title="page_title_email_editor"
                            element={
                                <MarketingManagementRoute>
                                    <EmailEditor />
                                </MarketingManagementRoute>
                            }
                        />
                    }
                />
                <Route
                    path="/initial-setup"
                    element={
                        <RouteOnMount
                            title="page_title_email_marketing_setup"
                            onMount={() => {}}
                            element={
                                <MarketingManagementRoute>
                                    <InitialSetup onManageSubscribers={handleOpenSubscribers} />
                                </MarketingManagementRoute>
                            }
                        />
                    }
                />
                <Route
                    path="/new"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_create"
                            element={
                                <MarketingManagementRoute>
                                    <MarketingCampaignsForm />
                                </MarketingManagementRoute>
                            }
                        />
                    }
                />
                <Route
                    path="/edit/:id"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_edit"
                            onMount={() => {
                                logMarketingCampaignsEvent({
                                    submodule: 'campaign',
                                    functionality: 'update',
                                });
                            }}
                            element={
                                <MarketingManagementRoute>
                                    <MarketingCampaignsForm />
                                </MarketingManagementRoute>
                            }
                        />
                    }
                />
                <Route
                    path="/settings/*"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_settings"
                            element={
                                <MarketingManagementRoute>
                                    <MarketingSettings />
                                </MarketingManagementRoute>
                            }
                        />
                    }
                />
                <Route
                    path="*"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns"
                            element={
                                <MarketingGeneralRoute>
                                    <MarketingCampaigns
                                        onManageSubscribers={handleOpenSubscribers}
                                    />
                                </MarketingGeneralRoute>
                            }
                        />
                    }
                />
            </Routes>
            <Subscribers isOpen={isSubscribersOpen} onClose={handleCloseSubscribers} />
        </>
    );
});

export default MarketingCampaignsContainer;
